import { gql } from "@apollo/client";

export const UPDATE_NOTIFICATION = gql`
  mutation UpdateNotification(
    $data: NotificationDataInput
    $where: NotificationWhereInput
  ) {
    updateNotification(data: $data, where: $where) {
      id
      type
      importance
      title
      content
      meta
      createdDate
      isReadBy {
        id
      }
    }
  }
`;

export const UPDATE_NOTIFICATIONS = gql`
  mutation UpdateNotifications(
    $data: NotificationDataInput
    $where: NotificationWhereInput
  ) {
    updateNotifications(data: $data, where: $where) {
      id
      type
      importance
      title
      content
      meta
      createdDate
      isReadBy {
        id
      }
    }
  }
`;

const notifications = { UPDATE_NOTIFICATION, UPDATE_NOTIFICATIONS };

export default notifications;
